import React from 'react';

interface IHintIconWarnProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const HintIconWarn = ({ size = '24', className = '', fill = '#F18700' }: IHintIconWarnProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-labelledby="hintIconWarn">
		<path
			d="M12 2C14.6522 2 17.1959 3.05335 19.0713 4.92871C20.9467 6.80407 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C9.34784 22 6.80407 20.9467 4.92871 19.0713C3.05335 17.1959 2 14.6522 2 12C2 9.34784 3.05335 6.80407 4.92871 4.92871C6.80407 3.05335 9.34784 2 12 2ZM12 14C11.1716 14 10.5 14.6716 10.5 15.5C10.5 16.3284 11.1716 17 12 17C12.8284 17 13.5 16.3284 13.5 15.5C13.5 14.6716 12.8284 14 12 14ZM11 13H13L14 7H10L11 13Z"
			fill={fill}
		/>
	</svg>
);
